// SEO 配置 - 为每个路由定义独立的标题、描述和关键词
// 这些配置会在预渲染时被捕获到静态 HTML 中

export const defaultSEO = {
  title: 'Avelia | 持续工作的智能平台',
  description: 'Avelia 是一个面向持续工作的智能平台，让智能在项目、设备与真实环境之间自然流动。',
  keywords: 'Avelia, 智能工作平台, AI Agent, 节点执行, 任务编排, 项目化工作, 知识沉淀, 跨端协作',
  ogTitle: 'Avelia | 持续工作的智能平台',
  ogDescription: '让智能在项目、设备与真实环境之间自然流动，持续推进工作。',
  ogUrl: 'https://avelia.chat/',
  ogImage: 'https://avelia.chat/og-image.png',
  twitterTitle: 'Avelia | 持续工作的智能平台',
  twitterDescription: '让智能在项目、设备与真实环境之间自然流动，持续推进工作。'
}

// 页面特定 SEO 配置
export const pageSEO = {
  // 首页
  home: {
    title: 'Avelia - 让每一次意图直达真实世界',
    description: 'Avelia 让智能在项目、设备与环境之间自然流动，连接会话、任务、知识与节点执行。',
    keywords: 'Avelia, 持续工作, 智能平台, AI Agent, 节点执行, 项目化工作, 云端理解, 知识沉淀',
    ogTitle: 'Avelia - 持续工作的智能平台',
    ogDescription: '让每一次意图直达真实世界。',
    ogUrl: 'https://avelia.chat/',
    twitterTitle: 'Avelia - 持续工作的智能平台',
    twitterDescription: '让每一次意图直达真实世界。'
  },

  // 功能页
  features: {
    title: 'Avelia 平台能力 - 会话、任务、节点与知识的统一编排',
    description: '了解 Avelia 如何把会话层、任务层、项目层、知识层与节点层组织成同一套持续工作系统。',
    keywords: 'Avelia平台能力, 任务层, 节点层, 知识层, 项目层, 智能编排, 持续工作系统',
    ogTitle: 'Avelia 平台能力 - 持续工作的系统结构',
    ogDescription: '会话、任务、项目、知识与节点执行在同一条工作主链中协同。',
    ogUrl: 'https://avelia.chat/features',
    twitterTitle: 'Avelia 平台能力',
    twitterDescription: '会话、任务、项目、知识与节点执行的统一编排。'
  },

  // 下载页
  download: {
    title: 'Avelia 节点下载 - Windows、Linux、Android 节点入口',
    description: '查看 Avelia 节点下载页，了解 Windows、Linux 与 Android 节点如何接入同一条持续工作的执行链。',
    keywords: 'Avelia节点下载, Windows节点, Linux节点, Android节点, 节点执行网络, Avelia下载',
    ogTitle: 'Avelia 节点下载 - 跨端执行入口',
    ogDescription: 'Windows、Linux 与 Android 节点接入同一条持续工作的执行链。',
    ogUrl: 'https://avelia.chat/download',
    twitterTitle: 'Avelia 节点下载',
    twitterDescription: 'Windows、Linux 与 Android 节点接入同一条持续工作的执行链。'
  },

  // 文档中心
  docs: {
    title: 'Avelia 文档中心 - 按真实产品入口理解持续工作',
    description: '从私人助理、项目管理、知识库、节点管理到创意工坊，理解 Avelia 的真实使用路径与高频场景。',
    keywords: 'Avelia文档, 私人助理, 项目管理, 知识库, 节点管理, 创意工坊, 持续工作指南',
    ogTitle: 'Avelia 文档中心 - 真实使用路径指南',
    ogDescription: '按产品入口与高频任务理解 Avelia 如何推进持续工作。',
    ogUrl: 'https://avelia.chat/docs',
    twitterTitle: 'Avelia 文档中心',
    twitterDescription: '按产品入口与高频任务理解 Avelia 如何推进持续工作。'
  },

  // 使用手册
  manual: {
    title: 'Avelia 完整使用手册 - 从入门到精通的全方位指南',
    description: 'Avelia官方完整使用手册，涵盖所有功能模块的详细说明。包含图文教程、视频演示、最佳实践案例。无论你是新手还是高级用户，都能在这里找到需要的帮助。',
    keywords: 'Avelia手册, 完整指南, 使用说明书, 详细教程, 最佳实践, 用户手册',
    ogTitle: 'Avelia 完整使用手册',
    ogDescription: '涵盖所有功能的详细说明，图文教程、最佳实践案例。',
    ogUrl: 'https://avelia.chat/manual',
    twitterTitle: 'Avelia 完整使用手册',
    twitterDescription: '所有功能详细说明，图文教程、最佳实践案例。'
  },

  // 设计展示页（开发用，无需复杂SEO）
  designShowcase: {
    title: 'Avelia Design Showcase',
    description: 'Avelia设计展示页面 - 仅用于开发测试',
    keywords: 'design, showcase',
    ogTitle: 'Avelia Design Showcase',
    ogDescription: 'Design showcase for development',
    ogUrl: 'https://avelia.chat/design-showcase',
    twitterTitle: 'Avelia Design Showcase',
    twitterDescription: 'Design showcase for development'
  }
}

export const docsSectionSEO = {
  'platform-overview': {
    title: '如何快速建立正确用法 - Avelia Docs',
    description: '从私人助理开始，理解 Avelia 何时切到项目管理、知识库、创意工坊与节点管理。',
    keywords: 'Avelia入门, 私人助理, 项目管理, 节点管理, 知识库, Avelia Docs',
    ogTitle: '如何快速建立正确用法 - Avelia Docs',
    ogDescription: '先理解几个核心入口如何串成一条真实工作链。',
    ogUrl: 'https://avelia.chat/docs/platform-overview',
    twitterTitle: '如何快速建立正确用法 - Avelia Docs',
    twitterDescription: '先理解几个核心入口如何串成一条真实工作链。'
  },
  'getting-started': {
    title: '如何开始使用 - Avelia Docs',
    description: '学习第一次进入 Avelia 时，如何从私人助理到项目管理、知识库和节点接入跑通首条工作链。',
    keywords: 'Avelia开始使用, 私人助理, 项目管理, 知识库, 节点接入, Avelia Docs',
    ogTitle: '如何开始使用 - Avelia Docs',
    ogDescription: '从第一条目标消息到首个可执行结果，建立稳定起点。',
    ogUrl: 'https://avelia.chat/docs/getting-started',
    twitterTitle: '如何开始使用 - Avelia Docs',
    twitterDescription: '从第一条目标消息到首个可执行结果，建立稳定起点。'
  },
  'conversation-tasks': {
    title: '会话与任务 - Avelia Docs',
    description: '了解如何在私人助理里发起目标、添加附件、选择技能、设置节点偏好并观察任务进展。',
    keywords: 'Avelia会话任务, 私人助理, 技能选择, 节点偏好, 任务推进, Avelia Docs',
    ogTitle: '会话与任务 - Avelia Docs',
    ogDescription: '从目标表达、附件挂载到任务回流，理解私人助理的真实用法。',
    ogUrl: 'https://avelia.chat/docs/conversation-tasks',
    twitterTitle: '会话与任务 - Avelia Docs',
    twitterDescription: '从目标表达、附件挂载到任务回流，理解私人助理的真实用法。'
  },
  'projects-knowledge': {
    title: '项目与知识 - Avelia Docs',
    description: '判断什么任务要先进项目管理，什么资料应该进入知识库，并理解两者如何配合。',
    keywords: 'Avelia项目管理, Avelia知识库, 工作容器, 资料沉淀, Avelia Docs',
    ogTitle: '项目与知识 - Avelia Docs',
    ogDescription: '让长期任务推进与长期资料沉淀同时成立。',
    ogUrl: 'https://avelia.chat/docs/projects-knowledge',
    twitterTitle: '项目与知识 - Avelia Docs',
    twitterDescription: '让长期任务推进与长期资料沉淀同时成立。'
  },
  'skills-nodes': {
    title: '技能与节点 - Avelia Docs',
    description: '理解技能调用、节点接入、能力清单和执行分配，知道什么时候自动分配，什么时候手动指定。',
    keywords: 'Avelia技能, Avelia节点, 节点接入, Linux节点, 节点分配, Avelia Docs',
    ogTitle: '技能与节点 - Avelia Docs',
    ogDescription: '围绕节点状态、能力清单和执行分配理解真实环境协同。',
    ogUrl: 'https://avelia.chat/docs/skills-nodes',
    twitterTitle: '技能与节点 - Avelia Docs',
    twitterDescription: '围绕节点状态、能力清单和执行分配理解真实环境协同。'
  },
  'collaboration-control': {
    title: '协作与控制 - Avelia Docs',
    description: '学习如何在私人助理、项目管理与群组协作之间选择合适推进方式，并为高风险任务保留控制点。',
    keywords: 'Avelia协作, 群组协作, 项目协作, 执行控制, Avelia Docs',
    ogTitle: '协作与控制 - Avelia Docs',
    ogDescription: '把目标、分工、执行与结果回流组织成一条可控链路。',
    ogUrl: 'https://avelia.chat/docs/collaboration-control',
    twitterTitle: '协作与控制 - Avelia Docs',
    twitterDescription: '把目标、分工、执行与结果回流组织成一条可控链路。'
  },
  'web-digital-projects': {
    title: '官网与数字项目 - Avelia Docs',
    description: '查看如何用私人助理、项目管理和知识库推进官网改版、落地页、文档站点与长期数字项目。',
    keywords: 'Avelia官网项目, 项目管理, 文档站点, 页面预览, Avelia Docs',
    ogTitle: '官网与数字项目 - Avelia Docs',
    ogDescription: '从目标提出到工作区预览，组织站点改版和数字项目迭代。',
    ogUrl: 'https://avelia.chat/docs/web-digital-projects',
    twitterTitle: '官网与数字项目 - Avelia Docs',
    twitterDescription: '从目标提出到工作区预览，组织站点改版和数字项目迭代。'
  },
  'creative-production': {
    title: '内容生产 - Avelia Docs',
    description: '理解如何在创意工坊里处理图片、视频、音频任务，并把提示词、参考素材和结果做成复用资产。',
    keywords: 'Avelia内容生产, 创意工坊, 图片视频音频, 参考素材, Avelia Docs',
    ogTitle: '内容生产 - Avelia Docs',
    ogDescription: '把创意任务从单次生成，推进成可复用的内容资产。',
    ogUrl: 'https://avelia.chat/docs/creative-production',
    twitterTitle: '内容生产 - Avelia Docs',
    twitterDescription: '把创意任务从单次生成，推进成可复用的内容资产。'
  },
  'remote-operations': {
    title: '远程运维 - Avelia Docs',
    description: '围绕 Linux 节点处理服务器巡检、部署检查、日志核对、数据库查询和缓存状态确认等高频任务。',
    keywords: 'Avelia远程运维, Linux节点, 部署检查, 服务器巡检, 数据库查询, Avelia Docs',
    ogTitle: '远程运维 - Avelia Docs',
    ogDescription: '让 Linux 节点承接高频远程环境与运维任务。',
    ogUrl: 'https://avelia.chat/docs/remote-operations',
    twitterTitle: '远程运维 - Avelia Docs',
    twitterDescription: '让 Linux 节点承接高频远程环境与运维任务。'
  },
  'desktop-execution': {
    title: '桌面执行 - Avelia Docs',
    description: '了解如何把本机观察、窗口与文件操作、应用处理和结果回流组织成桌面任务链。',
    keywords: 'Avelia桌面执行, 窗口观察, 应用操作, 本机排查, Avelia Docs',
    ogTitle: '桌面执行 - Avelia Docs',
    ogDescription: '把本机状态观察、应用操作与结果回流组织到同一任务链。',
    ogUrl: 'https://avelia.chat/docs/desktop-execution',
    twitterTitle: '桌面执行 - Avelia Docs',
    twitterDescription: '把本机状态观察、应用操作与结果回流组织到同一任务链。'
  },
  'mobile-node-workflows': {
    title: '移动端节点 - Avelia Docs',
    description: '理解移动端节点如何让设备参与界面观察、流程执行和跨端结果回流。',
    keywords: 'Avelia移动端节点, Android节点, 移动执行, 跨端回流, Avelia Docs',
    ogTitle: '移动端节点 - Avelia Docs',
    ogDescription: '让移动设备参与观察、执行与结果回流。',
    ogUrl: 'https://avelia.chat/docs/mobile-node-workflows',
    twitterTitle: '移动端节点 - Avelia Docs',
    twitterDescription: '让移动设备参与观察、执行与结果回流。'
  },
  'team-workflows': {
    title: '团队工作流 - Avelia Docs',
    description: '查看如何围绕负责人、成员、资料、节点和阶段性交付，组织一条可控的团队推进链。',
    keywords: 'Avelia团队工作流, 项目协作, 群组协作, 节点协作, Avelia Docs',
    ogTitle: '团队工作流 - Avelia Docs',
    ogDescription: '让负责人、成员、资料和节点围绕同一目标协同推进。',
    ogUrl: 'https://avelia.chat/docs/team-workflows',
    twitterTitle: '团队工作流 - Avelia Docs',
    twitterDescription: '让负责人、成员、资料和节点围绕同一目标协同推进。'
  },
  'suitable-tasks': {
    title: '什么任务最适合现在开始 - Avelia Docs',
    description: '快速判断哪些目标最适合在 Avelia 上起步，包括长链任务、跨端执行、内容生产和需要沉淀结果的工作。',
    keywords: 'Avelia适合任务, 长链任务, 跨端执行, 结果沉淀, Avelia Docs FAQ',
    ogTitle: '什么任务最适合现在开始 - Avelia Docs',
    ogDescription: '快速判断哪类任务最容易在 Avelia 上看到价值。',
    ogUrl: 'https://avelia.chat/docs/suitable-tasks',
    twitterTitle: '什么任务最适合现在开始 - Avelia Docs',
    twitterDescription: '快速判断哪类任务最容易在 Avelia 上看到价值。'
  },
  'what-is-a-node': {
    title: '节点如何参与工作 - Avelia Docs',
    description: '理解节点如何把桌面、Linux 环境和移动设备接入同一条任务链，并回传执行结果。',
    keywords: 'Avelia节点, 节点执行, Linux节点, 设备接入, Avelia Docs FAQ',
    ogTitle: '节点如何参与工作 - Avelia Docs',
    ogDescription: '让节点把真实设备与环境接入到 Avelia 的工作链中。',
    ogUrl: 'https://avelia.chat/docs/what-is-a-node',
    twitterTitle: '节点如何参与工作 - Avelia Docs',
    twitterDescription: '让节点把真实设备与环境接入到 Avelia 的工作链中。'
  },
  'project-vs-knowledge': {
    title: '项目管理与知识库怎么分工 - Avelia Docs',
    description: '了解项目管理与知识库分别承接什么内容，以及它们如何一起支撑长期任务。',
    keywords: 'Avelia项目管理, Avelia知识库, 分工, 长期任务, Avelia Docs FAQ',
    ogTitle: '项目管理与知识库怎么分工 - Avelia Docs',
    ogDescription: '明确长期任务推进与长期资料沉淀如何分工配合。',
    ogUrl: 'https://avelia.chat/docs/project-vs-knowledge',
    twitterTitle: '项目管理与知识库怎么分工 - Avelia Docs',
    twitterDescription: '明确长期任务推进与长期资料沉淀如何分工配合。'
  },
  'why-not-chat-product': {
    title: '为什么适合持续工作 - Avelia Docs',
    description: '理解 Avelia 如何把目标、执行面、过程状态和结果沉淀连接成同一条持续工作链。',
    keywords: 'Avelia持续工作, 项目沉淀, 环境执行, 任务链, Avelia Docs FAQ',
    ogTitle: '为什么适合持续工作 - Avelia Docs',
    ogDescription: '理解 Avelia 为什么适合多阶段、可回流的真实任务。',
    ogUrl: 'https://avelia.chat/docs/why-not-chat-product',
    twitterTitle: '为什么适合持续工作 - Avelia Docs',
    twitterDescription: '理解 Avelia 为什么适合多阶段、可回流的真实任务。'
  },
  'capability-boundaries': {
    title: '哪些能力可以立即开始 - Avelia Docs',
    description: '知道哪些能力现在就能直接启动，哪些方向需要节点、资料、权限或环境条件准备好之后再推进。',
    keywords: 'Avelia能力边界, 节点接入, 知识库资料, 环境条件, Avelia Docs FAQ',
    ogTitle: '哪些能力可以立即开始 - Avelia Docs',
    ogDescription: '先知道什么可以立即开始，再决定哪些任务要等节点或资料准备好。',
    ogUrl: 'https://avelia.chat/docs/capability-boundaries',
    twitterTitle: '哪些能力可以立即开始 - Avelia Docs',
    twitterDescription: '先知道什么可以立即开始，再决定哪些任务要等节点或资料准备好。'
  }
}

const validDocsSections = new Set([
  ...Object.keys(docsSectionSEO)
])

function normalizeSeoPath(path = '') {
  if (!path) {
    return ''
  }

  return path.replace(/^\/+/, '').replace(/\/+$/, '')
}

// 根据路径获取 SEO 配置
export function getSEOByPath(path) {
  const cleanPath = normalizeSeoPath(path)
  
  // 映射路径到配置 key
  const pathMap = {
    '': 'home',
    'features': 'features',
    'download': 'download',
    'docs': 'docs',
    'manual': 'manual',
    'design-showcase': 'designShowcase'
  }

  // 处理文档子页面
  if (cleanPath.startsWith('docs/')) {
    const docSection = cleanPath.replace('docs/', '')
    if (!validDocsSections.has(docSection)) {
      return pageSEO.docs
    }

    return docsSectionSEO[docSection] || pageSEO.docs
  }

  const key = pathMap[cleanPath]
  return pageSEO[key] || defaultSEO
}
